import {
  expansion_styles_default
} from "./chunk.VKRS5Z7M.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/expansion/expansion.ts
import { t } from "i18next";
var FadvExpansion = class extends s {
  constructor() {
    super(...arguments);
    this.fixed = false;
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleDocumentKeyDown = this.handleDocumentKeyDown.bind(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.hide();
  }
  handleDocumentKeyDown(e2) {
    if (e2.key === "Escape") {
      this.hide();
    }
  }
  handleOpenChange() {
    if (this.open) {
      document.addEventListener("keydown", this.handleDocumentKeyDown);
    } else {
      document.removeEventListener("keydown", this.handleDocumentKeyDown);
    }
  }
  show() {
    if (this.open) {
      return;
    }
    const showEvent = emit(this, "sl-show");
    if (showEvent.defaultPrevented) {
      this.open = true;
      return;
    }
    this.open = true;
    emit(this, "sl-after-show");
  }
  hide() {
    if (!this.open) {
      return;
    }
    const hideEvent = emit(this, "sl-hide");
    if (hideEvent.defaultPrevented) {
      this.open = false;
      return;
    }
    this.open = false;
    emit(this, "sl-after-hide");
  }
  handleClick() {
    return this.open ? this.hide() : this.show();
  }
  renderExpandPanelButton() {
    if (this.open || this.fixed)
      return w;
    return $`<button id="expand-button" class="expansion--trigger" aria-expanded="false" aria-haspopup="true" aria-controls="panel" @click=${this.handleClick.bind(this)} ><fadv-icon foreground="primary" size="x-small" library="solid" name="${this.open === void 0 ? "fa-arrow-down" : "fa-arrow-up"}" label="${t("components:expansion.expandPanel")}" ></fadv-icon></button>`;
  }
  renderCollapsePanelButton() {
    if (!this.open || this.fixed)
      return w;
    return $`<button id="collapse-button" class="expansion--trigger" aria-expanded="true" aria-haspopup="true" aria-controls="panel" @click=${this.handleClick.bind(this)} ><fadv-icon foreground="primary" size="x-small" library="solid" name="fa-arrow-down" label="${t("components:expansion.collapsePanel")}" ></fadv-icon></button>`;
  }
  render() {
    return $`<div part="base" class=${o({
      expansion: true,
      "expansion--open": !!this.open,
      "expansion--close": this.open === false,
      "expansion--fixed": !!this.fixed
    })} ><div class="card"><slot></slot>${this.renderExpandPanelButton()}</div><div class="expansion__panel" part="panel" aria-hidden=${!this.open} id="panel"><div><slot name="panel"></slot></div></div>${this.renderCollapsePanelButton()}</div>`;
  }
};
FadvExpansion.styles = expansion_styles_default;
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvExpansion.prototype, "open", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvExpansion.prototype, "fixed", 2);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], FadvExpansion.prototype, "handleOpenChange", 1);
FadvExpansion = __decorateClass([
  n("fadv-expansion")
], FadvExpansion);

export {
  FadvExpansion
};
